import {GAME_REDIRECT_SET, PAGE_SET, SEARCH_SET,} from "../Core/myResultsActions";
import {GAMES_UPDATE} from "../LastUpdated/lastUpdatedActions";

export const RANKING_SET = 'RANKING_SET';
export const RANKING_SET_ENTRIES_OWN = 'RANKING_SET_ENTRIES_OWN';

const cacheReducer = (state = {}, action) => {
    if (action.fromCache || action.payload.search) {
        return state;
    }
    switch (action.type) {
        case GAMES_UPDATE:
            //clear cache
            return {};
        case RANKING_SET:
            return {
                ...state,
                [action.payload.classificationId]: {
                    classificationId: action.payload.classificationId,
                    entries: {
                        1: action.payload.entries
                    },
                    pagesTotal: action.payload.pagesTotal,
                    columns: action.payload.columns,
                    result: action.payload.result,
                    entriesOwn: action.payload.entriesOwn || null
                }
            };
        case RANKING_SET_ENTRIES_OWN:
            return {
                ...state,
                [action.payload.classificationId]: {
                    ...state[action.payload.classificationId],
                    entriesOwn: action.payload.entries
                }
            };
        case PAGE_SET:
            return {
                ...state, [action.payload.classificationId]: {
                    ...state[action.payload.classificationId],
                    entries: {
                        ...state[action.payload.classificationId].entries,
                        [action.payload.page]: action.payload.entries
                    }
                }
            };
        default:
            return state;
    }
};


export const rankingReducer = (state = {
    cache: {},
    entries: [],
    page: null,
    pagesTotal: null,
    entriesOwn: [],
    search: null,
    columns: [],
    redirectUrl: null,
    result: null
}, action) => {
    switch (action.type) {
        case GAME_REDIRECT_SET:
            return {
                ...state,
                entries: [],
                page: null,
                pagesTotal: null,
                entriesOwn: [],
                result: null,
                search: null,
                columns: [],
                redirectUrl: action.payload.url
            };
        case RANKING_SET:
            return {
                ...state,
                cache: cacheReducer(state.cache, action),
                page: 1,
                entries: action.payload.entries,
                pagesTotal: action.payload.pagesTotal,
                entriesOwn: action.payload.entriesOwn || null,
                columns: action.payload.columns,
                result: action.payload.result,
                search: null,
                redirectUrl: null
            };
        case RANKING_SET_ENTRIES_OWN:
            return {
                ...state,
                cache: cacheReducer(state.cache, action),
                entriesOwn: action.payload.entries,
            };
        case SEARCH_SET:
            return {
                ...state,
                page: action.payload.page,
                entries: action.payload.entries,
                search: action.payload.search,
                pagesTotal: action.payload.pagesTotal
            };
        case PAGE_SET:
            return {
                ...state,
                cache: cacheReducer(state.cache, action),
                page: action.payload.page,
                entries: action.payload.entries,
                search: action.payload.search
            };
        default:
            return state;
    }
};
export const setEntriesOwnAction = (classificationId, entries) => {
    return {
        type: RANKING_SET_ENTRIES_OWN,
        payload: {
            classificationId,
            entries
        }
    }
};
export const setRankingAction = (ranking, result, entries, fromCache = false) => ({
    type: RANKING_SET,
    payload: {...ranking, entries: entries, result: result},
    fromCache: fromCache
});